export interface MarketingCompanyLogo {
  name: string;
  lightImageSrc: string;
  darkImageSrc: string;
  alt: string;
}

export const MARKETING_COMPANY_LOGOS: MarketingCompanyLogo[] = [
  {
    name: 'Apollo',
    lightImageSrc: '/images/logos/image 441.png',
    darkImageSrc: '/images/logos/image 441-dark.png',
    alt: 'Apollo logo',
  },
  {
    name: 'beehiiv',
    lightImageSrc: '/images/logos/image 442.png',
    darkImageSrc: '/images/logos/image 442-dark.png',
    alt: 'beehiiv logo',
  },
  {
    name: 'Notion',
    lightImageSrc: '/images/logos/image 443.png',
    darkImageSrc: '/images/logos/image 443-dark.png',
    alt: 'Notion logo',
  },
  {
    name: 'ClickUp',
    lightImageSrc: '/images/logos/image 444.png',
    darkImageSrc: '/images/logos/images 444-dark.png',
    alt: 'ClickUp logo',
  },
];
